import styled from '@emotion/styled'
import EdgeImg from 'components/feature/EdgeImg'
import { Icon } from 'components/patterns'

import { wrap as withStyle } from 'utils/styles'

export default withStyle(
  (props) => `
  display: flex;
  ${props.vertical ? 'flex-direction: column;' : ''}
`
)

export const StyledEdgeImg = styled(EdgeImg)`
  margin-left: 2px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledHysteresisEdge = styled.span`
  margin-left: auto;
  align-items: center;
  display: flex;
  white-space: nowrap;
  ${({ isSimulating }) =>
    isSimulating
      ? `${StyledEdgeImg} { margin-right: 0; }
      ${Icon} { margin-right: 10px; }
      `
      : ''}
`

export const ContentWrapper = styled.span`
  width: 100%;
  display: flex;
  height: 100%; // ie11

  &.editor-section {
    margin-top: 10px;
  }

  &.condition-item {
    margin-top: 5px;
  }
`

export const RungContent = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 290px;
  min-width: 0;
`

export const ConditionContextText = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const RungLabel = styled.label``
